import mapValuesToRequest, { IRequestBody } from './mappers/mapValuesToRequest'
import handleResponse from './request/handleResponse'
import { RoomType } from './index'

export default function(api: GlobalFetch) {
  return async function(calendarId: number, room: IRequestValues) {
    const requestBody: IRequestBody = mapValuesToRequest(calendarId, {
      id: '0',
      ...room,
    })
    const response = await api.fetch(`/api/v2/room/index`, {
      body: JSON.stringify(requestBody),
      method: 'POST',
    })

    return await handleResponse(response)
  }
}

export interface IRequestValues {
  name?: string
  type?: RoomType
  description?: string

  roomSize?: number
  additionalBeds?: number
  size?: any
  additionalEquipment?: any
  coords_lat?: string
  coords_lng?: string
  widget?: number

  singleBed?: number
  doubleBed?: number

  customColor?: string
  position?: number
}
